import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import Cookies from 'universal-cookie';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./css/main-menu.css";

// Components
import AiAssistant from "../../common/components/AIChatBubble/AiAssistant";

// Pages
import Pro from "./pages/Pro";
import Addons from "./pages/Addons";
import Help from "./pages/Help";

const App = () =>{
    const defaultTab = "/pro";
    const [activeTab, setActiveTab] = useState(
        window.location.hash.replace("#", "") || defaultTab
    );
    const [user, setUser] = useState(null);
    const [showAPIModal, setShowAPIModal] = useState(false);

    useEffect(() => {
        const validTabs = ["/addons", "/help"];
        const handleHashChange = () => {
            const newHash = window.location.hash.replace("#", "");
            if (validTabs.includes(newHash)) {
                setActiveTab(newHash);
            } else {
                setActiveTab(defaultTab);
                window.location.hash = "";
            }
        };

        window.addEventListener("hashchange", handleHashChange);

        // Initial check to ensure correct tab is set on page load
        handleHashChange();

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    useEffect(() => {
        // Check if user is connected
        const cookies = new Cookies(null, { path: '/' });
        const user = cookies.get('easy-user');

        if (!user) {
            fetch(`${EASYCOMMERCE.rest_base}/connectivity/check`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': EASYCOMMERCE.nonce,
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success && data.data.connected) {
                        setUser(data.data.user);
                        cookies.set('easy-user', JSON.stringify(data.data.user), {
                            path: '/',
                            maxAge: 86400 * 30,
                        });
                    }
                });
        } else {
            setUser(user);
        }
    }, []);

    return (
        <div className="min-h-screen bg-ec-main-bg">
            {activeTab === "/pro" && <Pro />}
            {activeTab === "/addons" && <Addons />}
            {activeTab === "/help" && <Help />}

            <ToastContainer />
            <AiAssistant user={user} setShowAPIModal={setShowAPIModal} />
        </div>
    );
};

// Assuming the container exists in your HTML file
const container = document.getElementById("easycommerce_render");
const root = createRoot(container);
root.render(<App />);

export default App;
